<template>
  <lego-modal-extend-v-2
    ref="modal"
    :title="title"
    :customStyle="{
      body: {
        overflow: 'visible'
      }
    }"
    @beforeClose="cancelMsg"
    :sub-title="targetData.productName || groupName"
  >
    <div class="select-table-container">
      <div class="select-formbox-wrap">
        <div class="selectbox-col">
          <c-scroll :classStyle="'height-scroll'">
            <div class="target-grid" v-if="detailData.productSummary">
              <div class="target-wrapper">
                <target-list
                  :productId="productId"
                  :targetData="targetData"
                  :productTypeCode="resourceType"
                  :productIp="productIp"
                  :chipItems="tagChip"
                  :productLbServiceIp="productLbServiceIp"
                />
              </div>
            </div>

            <div class="target-grid" v-if="detailData.groupSummary">
              <div class="target-wrapper">
                <div class="target-item">
                  <div class="target-item__label">{{ $t('label.targetName') }}</div>
                  <div class="product-type-item-detail">
                    <c-asg />
                    <div v-lego-tooltip:ellipsis="groupName" class="ellipsis">{{ groupName }}</div>
                  </div>
                  <div class="target-item__label server-list">{{ $t('label.serverList') }}</div>
                  <c-label v-if="serverList.length === 0">
                    <c-nodata></c-nodata>
                  </c-label>
                  <div
                    v-else
                    class="product-type-item-detail"
                    v-for="(item, index) in serverList"
                    :key="index"
                  >
                    <div
                      class="asg-product-name ellipsis"
                      v-lego-tooltip:ellipsis="item.productName"
                    >
                      {{ item.productName }}
                    </div>
                  </div>
                  <div class="server-list">
                    <TagBox :label="$t('searchLabel.tagInfo')" :tagItems="tagChip" />
                  </div>
                </div>
              </div>
            </div>
          </c-scroll>
        </div>
        <div class="formbox-col">
          <div class="tab-wrapper">
            <lego-tab-box class="tabbox" :default-idx="tabIndex" @tab-change="tabChange">
              <lego-tab-label class="tabbox-item" :idx="1"
                >{{ t('page.eventStatus.settingInfoTab') }}
              </lego-tab-label>
              <lego-tab-label class="tabbox-item" :idx="2"
                >{{ t('page.eventStatus.historyTab') }}
              </lego-tab-label>
            </lego-tab-box>
          </div>
          <div class="tabs-container">
            <div v-show="tabIndex === 1">
              <!-- // 모니터링 대상 -->
              <!-- 이벤트 조건 -->
              <div class="table-header-wrap" style="padding-top: 24px">
                <div class="left-con">
                  <div class="subtitle">
                    {{ t('page.eventStatus.eventConditions') }}
                    <!-- <span class="required" v-show="!isViewMode">*</span> -->
                  </div>
                  <!--이벤트 조건 -->
                </div>
              </div>
              <div v-if="ruleModel">
                <EventRuleItem
                  ref="ruleItem"
                  class="todo"
                  :productsModel="productsModel"
                  :detailData="detailData"
                  v-model="ruleModel"
                  :resourceTypeModel="resourceType"
                  :resourceTypeModel2="objectType"
                  :objectDisplayName="objectDisplayName"
                  :metricSummary="{
                    ...detailData.metricSummary,
                    disableObject: detailData.disableObject
                  }"
                  :disabled="readonly"
                  :removeable="false"
                  :mode="mode"
                  @change-data="changeData"
                  @update:Validate="checkValidDate"
                  @setObjectName="setObjectName"
                  :readonly="true"
                  :isASG="detailData.asgYn"
                  :needCheckPerformance="true"
                />
              </div>
              <!-- // 이벤트 조건 -->
              <Notifications
                v-if="notificationsModel"
                ref="notifications"
                :valueTmp="notificationsModel"
                :rules="[ruleModel]"
                :readonly="true"
                :mode="mode"
                :userName="userName"
                @change-data="changeData"
                @confirmModifyInfo="onConfirmModify"
                :scrollMaxRow="lineTable"
                class="notifications-wrapper"
              />
            </div>
            <div style="margin-top: 8px" v-show="tabIndex === 2">
              <lego-paging-table
                isNotScrollX
                :items="historyItems"
                :headers="historyHeaders"
                @click-row="clickRow"
                :scrollMaxRow="historyLine"
                @sort="onSortChange"
                @change="changeRowPerPage"
                @pageMove="changeCurrentPage"
                :pagination="page"
                ref="eventHistoryTable"
              >
                <template #expand>
                  <div class="history-tab">
                    <EventRuleItem
                      ref="ruleItem"
                      :hasBorder="false"
                      isHistory
                      :isChangeHistories="true"
                      v-if="ruleHistroyModel && metricsOrg"
                      :productsModel="productsModel"
                      :detailData="detailData"
                      class="todo"
                      :metrics="metricsOrg"
                      :resourceTypeModel="resourceType"
                      :resourceTypeModel2="objectType"
                      :objectDisplayName="objectDisplayName"
                      v-model="ruleHistroyModel"
                      :disabled="true"
                      :removeable="false"
                      :mode="mode"
                      :needCheckPerformance="true"
                      :hiddenIndividualItem="
                        Object.keys(ruleHistroyModel).length &&
                        ruleHistroyModel.disableObject == 'Y'
                      "
                    />
                  </div>
                </template>
                <template #extra-action>
                  <scpm-filter-dialog
                    ref="refFilterEventHistory"
                    :schema="searchSchema"
                    :model="searchModel"
                    @reset="onReset"
                    @searchField="onSearchField"
                    @search="onSearch"
                    :placeholder="
                      $t('searchLabel.searchLikeAoe', { VPC: $t('page.eventStatus.modifier') })
                    "
                  />
                </template>
              </lego-paging-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <lego-button v-if="mode == 'modify'" border @click="cancelMsg"
        >{{ t('button.cancel') }}
      </lego-button>
      <lego-button v-if="isViewMode" @click="closeModal" border
        >{{ t('button.close') }}
      </lego-button>
      <lego-button v-if="isViewMode" main @click="onConfirmClick"
        >{{ t('button.edit') }}
      </lego-button>
      <lego-button
        v-else
        :disabled="!validateRules || !changedFieldData || isNoMethodSelect"
        main
        @click="onConfirmClick"
      >
        {{ mode == 'modify' ? t('button.save') : t('button.confirm') }}
      </lego-button>
    </template>
  </lego-modal-extend-v-2>
</template>
<script>
import EventRuleItem from './components/EventRuleItem';
import Notifications from './components/Notifications';
import i18nMixin from '@/mixins/i18n.mixin.js';
import LegoModalExtendV2 from '../../../components/lego/extend/legoModalExtendV2.vue';
import TagBox from '@/containers/popup/components/TagBoxV3.vue';
import monTargetMixin from '../../popup/monTarget.mixin';
import TargetList from './components/TargetList.vue';
import { PRODUCT_TYPES } from '@/containers/utils/constant.js';
import validateFieldsMixin from '@/mixins/validateFields.mixin';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';
import { useProductTypeGroups } from '@/composables/useProductTypeGroups.js';
import { mapGetters } from 'vuex';

const { getProductTypeGroups } = useProductTypeGroups();
const { formatDateTime, FULL_TIME_FORMAT } = useDateTimeFormat();

export default {
  mixins: [i18nMixin, monTargetMixin, validateFieldsMixin],
  components: { EventRuleItem, Notifications, LegoModalExtendV2, TargetList, TagBox },
  emits: ['close', 'open-event-edit-modal'],
  computed: {
    ...mapGetters('searchStore', { isResetFilterXss: 'getResetFilterXss' }),
    isNoMethodSelect() {
      return !!this.notificationsModel.find(
        (e) => e.notificationMethods[0].sendMethod.length === 0
      );
    },
    lineTable() {
      return this.mode == 'view' ? 7.4 : 5;
    },
    historyLine() {
      const numberOfLine = 19;
      const isHasPagination = this.page.totalItems > this.page.rowsPerPage;
      return isHasPagination ? numberOfLine - 2 : numberOfLine - 0.5;
    },
    readonly() {
      return this.mode == 'view';
    },
    isViewMode() {
      return this.mode == 'view';
    },
    is2ndDropDown() {
      return this.lstSubResourceType.includes(this.resourceType) ? true : false;
    }
  },
  props: {
    seq: {
      type: [String, Number],
      required: true
    },
    resourceType: {
      type: [String, Number],
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      serverList: [],
      groupName: '',
      validateFieldKey: 'eventSettingEdit',
      page: {
        rowsPerPage: 20,
        currentPage: 1,
        totalItems: 0,
        currentIndex: 0
      },
      sort: {
        sortDataField: '',
        sortOrder: ''
      },
      tabIndex: 1,
      isCheckChangeData: false,
      tagChip: [],
      productIp: '',
      productLbServiceIp: '',
      productProductState: '',
      productId: '',
      targetData: {},
      lstSubResourceType: [
        'Kubernetes',
        'Load Balancer',
        'DataOps',
        'DataFlow',
        'QuickQuery',
        'DataWrangler'
      ],
      mode: 'view',
      productsModel: [],
      detailData: {},
      ruleModel: null,
      ruleHistroyModel: null,
      notificationsModel: null,
      historyTotal: null,
      historyItems: [],
      historySelected: [],
      metricsOrg: [],
      iconProductType: '',
      historyHeaders: [
        {
          text: this.$t('page.eventStatus.type'), //유형
          value: 'eventPolicyHistoryType',
          width: 315,
          defaultValue: '-',
          sortable: true,
          customCell: (value) => {
            const text =
              value == 'C'
                ? this.t('label.register')
                : value == 'U'
                ? this.t('label.modify')
                : this.t('label.delete');
            return `<div class="ellipsis" v-lego-tooltip:ellipsis="'${text}'">${text}</div>`;
          }
        },
        {
          text: this.$t('page.eventStatus.modifier'), //수정자
          value: 'modifiedByName',
          defaultValue: '-',
          sortable: true,
          width: 460,
          customSortField: 'modifier'
        },
        {
          text: this.$t('page.eventStatus.changeTime'), //변경시각
          value: 'modifiedDt',
          defaultValue: '-',
          sortable: true,
          customCell: (value) => {
            const text = formatDateTime(value, FULL_TIME_FORMAT);
            return `<div class="ellipsis" v-lego-tooltip:ellipsis="'${text}'">${text}</div>`;
          },
          bodyAlign: 'center',
          width: 400
        }
      ],
      productItems: [
        {
          label: this.$t('page.eventStatus.target'), //대상명
          value: ''
          // model: 'productSummary.productResourceId',
        },
        {
          label: this.$t('page.eventStatus.product'), //상품
          value: '',
          col: 2
        },
        // {
        //   label: this.$t('page.eventStatus.ip'), //IP주소
        //   value: '',
        //   col: 3
        // },
        {
          label: this.$t('searchLabel.productState'), //상태
          value: '',
          col: 4
        }
      ],
      userName: '',
      objectDisplayName: '',
      objectType: '',
      objectTypeName: '',
      eventEditModalOpen: false,
      PRODUCT_TYPES: PRODUCT_TYPES,
      searchSchema: {
        fields: [
          {
            id: 'type',
            type: 'select-box',
            label: this.$t('page.eventStatus.type'),
            model: 'type',
            values: [
              { text: this.$t('label.modify'), key: 'U' },
              { text: this.$t('label.register'), key: 'C' }
            ]
          },
          {
            id: 'modifier',
            model: 'modifier',
            type: 'input',
            label: this.$t('page.eventStatus.modifier'), // IP 주소
            width: '100%',
            maxlength: 100,
            placeholder: this.$t('searchLabel.searchLikeAoe', {
              VPC: this.$t('page.eventStatus.modifier')
            })
          },
          {
            id: 'changeTime',
            model: 'changeTime',
            type: 'date-range',
            label: this.$t('page.eventStatus.changeTime'), // IP 주소
            width: '100%'
          }
        ]
      },
      searchModel: {
        type: [],
        modifier: '',
        changeTime: ''
      },
      queryHistory: {},
      validateRules: false,
      isFirst: true
    };
  },
  async created() {
    this.getIconProductType();
    await this.getDetailInfo();
    this.currentDataItem = this.$util.deepCopy(this.ruleModel);
    if (this.mode === 'modify') this.setFieldsBeforeModify();
  },
  mounted() {
    this.$refs['modal'].open();
  },
  methods: {
    getIconProductType() {
      this.$http.product.getProductTypeList().then(async (data) => {
        const productTypeGroups = await getProductTypeGroups(data);
        const group = this.getGroup(productTypeGroups, this.resourceType);
        if (group) {
          this.iconProductType = group.icon;
        }
      });
    },
    getGroup(listGroup, productTypeCode) {
      return listGroup.find((item) => {
        if (
          item.productTypeCode &&
          item.productTypeCode.toLowerCase() === productTypeCode.toLowerCase()
        ) {
          return item;
        } else if (item.childItems) {
          return this.getGroup(item.childItems, productTypeCode);
        }
      });
    },
    async getDetailInfo() {
      const detailApi = this.$http.event.get(
        `/v1/console/event-policies/${this.seq}`,
        null,
        true,
        false,
        {
          headers: { 'X-ResourceType': this.resourceType }
        }
      );
      const historyApi = this.$http.event.get(
        `/v1/console/event-policies/${this.seq}/notifications?size=100`,
        null,
        true,
        false,
        {
          headers: { 'X-ResourceType': this.resourceType }
        }
      );
      const [detail, history] = await Promise.all([detailApi, historyApi]).catch((e) => {
        this.$alert(e, () => {
          this.closeModal();
        });
      });

      // 임시 처리 (추가 api시 자동으로 pod 생성? ) objecttype값이 제거 확인후 삭제
      detail.objectName = (detail.objectName || '').replace('pod:', '');

      this.detailData = detail;
      if (detail.groupSummary) {
        this.serverList = detail.groupSummary.productList;
        this.groupName = detail.groupSummary.groupName;
        this.getTags(detail.groupSummary.groupResourceId, true);
      }
      if (detail.productSummary) {
        this.productItems[0].value = detail.productSummary.productName;
        this.productItems[1].value = detail.productSummary.productTypeName;
        this.productItems[1].iconProductType = this.iconProductType;

        switch (detail.productSummary.productTypeCode) {
          case this.PRODUCT_TYPES.CLOUD_WAN:
            this.productItems[0].label = this.$t('page.eventStatus.attachmentName');
            break;
          default:
            this.productItems[0].label = this.$t('page.eventStatus.target');
            break;
        }
        this.productItems[2].value = this.$util.runningIcon(
          detail.productSummary.productState,
          detail.productSummary.productState
        );
        this.objectType = detail.productSummary.productSubType || detail.objectType;
        this.productsModel = detail.productSq
          ? [
              {
                productSq: detail.productSq,
                objectName: detail.productSummary.productSubName || detail.objectName
              }
            ]
          : null;
        this.getDetail(detail.productSq);
        this.getTags(detail.productResourceId);
      }

      this.ruleModel = EventRuleItem.methods.ruleToRuleItem.call(this, detail);
      this.ruleModel.isObjectExist = detail.metricSummary.isObjectExist;
      this.ruleModel.objectModel = detail.objectName;
      this.ruleModel.objectDisplayName = detail.objectDisplayName;
      this.ruleModel.disableYn = detail.disableYn || 'N';
      this.ruleModel.disableObject = detail.disableObject;
      this.ruleModel.productSummary = detail.productSummary || detail.groupSummary;
      this.objectDisplayName = detail.objectDisplayName;

      this.objectTypeName = detail.objectTypeName;
      // v1/console/metrics 삭제후 적용
      this.metricsOrg = [detail.metricSummary];
      // /v1/console/products/summaries 삭제후 적용
      history.contents.forEach((item) => {
        if (item.recipientType == 'ADDRBOOK') {
          if (item.addrbookAdditionalInfo.memberCount > 0) {
            this.userName =
              item.addrbookAdditionalInfo.userAdditionalInfo[0].userName ||
              item.addrbookAdditionalInfo.userAdditionalInfo[0].user_name;
          }
        }
      });

      this.notificationsModel = history.contents.sort((a, b) => {
        if (a.recipientType === 'ADDRBOOK' && b.recipientType !== 'ADDRBOOK') {
          return -1;
        } else if (a.recipientType !== 'ADDRBOOK' && b.recipientType == 'ADDRBOOK') {
          return 1;
        } else {
          return 0;
        }
      });

      this.getHistoryData();
    },
    checkValidDate(value) {
      if (value) {
        this.validateRules = value.valid;
      } else {
        this.validateRules = false;
      }
    },
    onReset() {
      this.searchModel = {
        type: [],
        modifier: '',
        changeTime: ''
      };
      this.sort = {
        sortDataField: '',
        sortOrder: ''
      };

      this.queryHistory = {};
      this.page.currentPage = 1;
      this.getHistoryData();
      if (typeof this.$refs.eventHistoryTable != 'undefined') {
        this.$refs.eventHistoryTable.$refs.table.resetSort();
      }
    },
    onSearchField(field, value) {
      this.searchModel = {};
      this.queryHistory = {};
      this.queryHistory[field] = value;
      this.getHistoryData(true);
    },
    onSearch() {
      let changeFromDt, changeToDt;
      if (this.searchModel.changeTime && this.searchModel.changeTime.length === 2) {
        const { fromDate, toDate } = this.$util.formatDateSearchQuery(
          this.searchModel.changeTime[0],
          this.searchModel.changeTime[1]
        );
        changeFromDt = fromDate;
        changeToDt = toDate;
      }
      this.queryHistory = {
        modifier: this.searchModel.modifier,
        ...(this.searchModel.type &&
          this.searchModel.type.length && {
            eventPolicyHistoryType:
              this.searchModel.type.length > 1 ? '' : this.searchModel.type[0].key
          }),
        ...(this.searchModel.changeTime && {
          changeFromDt,
          changeToDt
        })
      };
      this.getHistoryData(true);
    },
    changeRowPerPage() {
      this.page.currentPage = Math.ceil((this.page.currentIndex + 1) / this.page.rowsPerPage);
      this.page.currentIndex = (this.page.currentPage - 1) * this.page.rowsPerPage;
      this.getHistoryData();
    },
    changeCurrentPage(page) {
      this.page.currentPage = page;
      this.page.currentIndex = (page - 1) * this.page.rowsPerPage;
      this.getHistoryData();
    },
    async getHistoryData(isSearch = false) {
      if (isSearch) {
        this.page.currentPage = 1;
        this.page.currentIndex = 0;
      }
      const params = {
        size: this.page.rowsPerPage,
        page: this.page.currentPage - 1,
        ...this.queryHistory
      };
      const { sortDataField, sortOrder } = this.sort;

      if (sortDataField) {
        params.sort = [`${sortDataField}:${sortOrder}`];
      }

      const data = await this.$http.event
        .get(`/v1/console/event-policies/${this.seq}/histories`, params, true, false, {
          headers: { 'X-ResourceType': this.resourceType }
        })
        .catch((error) => {
          if (this.isResetFilterXss) {
            this.$refs.refFilterEventHistory?.onReset('error');
          }
        });

      if (data) {
        this.historyTotal = data.totalCount;
        this.page.totalItems = data.totalCount;
        this.historyItems = data.contents;
        if (Array.isArray(this.historyItems)) {
          this.historyItems.map((item) => {
            if (item.objectName) {
              item.objectName = item.objectName.replace('pod:', '');
            }
          });
        }
      }
    },
    onConfirmModify(notifications) {
      this.isCheckChangeData = true;
      this.notificationsModel = notifications;
    },
    tabChange(index) {
      this.tabIndex = index;
    },
    changeData() {
      this.isCheckChangeData = true;
    },
    async getDetail(productId) {
      await this.$http.product
        .getProductDetail({ productId }, this.resourceType, true)
        .then((data) => {
          if (this.$util.isNotEmpty(data)) {
            const productName = data.productName;
            this.detailData.productName = productName;
            if(this.detailData.productSummary?.productName){
              data.productName = this.detailData.productSummary.productName;
            }
            this.targetData = data;
            this.productId = productId;
            this.productIp = data.productIpAddress;
            this.productLbServiceIp = data.lbServiceIp; // LBS Service IP
          }
        })
        .catch((err) => {
          if (err && err.code == 'AccessDenied') {
            this.$alert(err);
          }
        });
    },
    closeModal() {
      this.$emit('close', { item: this.detailData });
    },
    cancelMsg() {
      if (this.isViewMode === true || !this.changedFieldData) {
        this.closeModal();
        return;
      }
      const message =
        `<div>` +
        this.t('message.notNotifyWritingInfo') +
        `</br>` +
        this.t('message.moveTheScreenNotify') +
        `</div>`;

      this.$alert(message, this.t('page.eventStatus.notice'), {
        action: () => {
          this.closeModal();
        },
        cancel: () => {}
      });
    },
    onConfirmClick() {
      const { groupSummary, productResourceId, productName } = this.detailData;
      const productResourceIds = [];
      const listDataCheckAuth = [];

      const resourceIds = groupSummary ? groupSummary.groupResourceId : productResourceId;
      productResourceIds.push(resourceIds);
      listDataCheckAuth.push({
        productResourceId: resourceIds,
        productName: groupSummary ? groupSummary.groupName : productName
      });

      const params = {
        productTypeCode: this.resourceType,
        actionName: 'MonitorSet',
        productResourceIds,
        listDataCheckAuth: listDataCheckAuth
      };

      this.$store
        .dispatch('authStore/checkProductResource', params)
        .then((data) => {
          if (data.type === this.$const.AuthorizationResult.ALLOW) {
            this.$emit('open-event-edit-modal');
          }
        })
        .catch((err) => {
          this.$alert(err);
        });
    },
    clickRow(item) {
      if (!this.$refs.eventHistoryTable) return;
      this.$refs.eventHistoryTable.$refs.table.onClickRowExpand(item, true);

      this.historySelected = [item];
      this.ruleHistroyModel = EventRuleItem.methods.ruleToRuleItem.call(this, item);

      if (item.objectName) {
        if (
          (this.resourceTypeModel === 'Kubernetes' && this.resourceTypeModel2 !== 'cluster') ||
          (['DataOps', 'DataFlow', 'Load Balancer'].includes(this.resourceTypeModel) &&
            this.resourceTypeModel2 !== 'service') ||
          (['QuickQuery', 'DataWrangler'].includes(this.resourceTypeModel) &&
            this.resourceTypeModel2 !== 'namespace')
        ) {
          this.ruleHistroyModel.objectItems = [
            {
              value: item.objectName,
              text: item.objectDisplayName
            }
          ];
        } else {
          this.ruleHistroyModel.objectModel = item.objectName;
          this.ruleHistroyModel.objectDisplayName = item.objectDisplayName;
          this.ruleHistroyModel.objectItems = [
            {
              value: item.objectName,
              text: item.objectName
            }
          ];
        }
        this.ruleHistroyModel.isObjectExist = 'Y';
        this.ruleHistroyModel.chkObjectItems = true;
      }
    },
    onSortChange(header) {
      const { value, asc, customSortField } = header;
      this.sort = {
        sortDataField: customSortField || value,
        sortOrder: asc ? 'asc' : 'desc'
      };
      this.getHistoryData();
    },
    closeEventEditModal() {
      this.eventEditModalOpen = false;
    },
    setObjectName(data = {}) {
      if (this.ruleModel && data.individualList && data.individualList.length) {
        this.ruleModel.objectItems = [...data.individualList];
      }
      if (this.mode === 'modify' && this.isFirst) {
        this.setFieldsBeforeModify(true);
        this.isFirst = false;
      }
    },
    getTags(productResourceId, isAsg = false) {
      this.apiGetTags(productResourceId, this.resourceType, isAsg).then((data) => {
        this.tagChip = this.$util.getListTag(data);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './styles/eventDetailModal.scss';

$layoutSelectboxColHeight: 702px;

.lego-tab__label-underline {
  color: #2e3138;
  border-bottom: 1px solid #e3e4e8;

  &--active {
    color: #2c5ad8;
    border-bottom-color: #2c5ad8;
  }
}

.lego-tab__label-underline:hover {
  color: #2c5ad8 !important;
}

:deep(.lego-tab__content-wrapper) {
  border-top: 1px solid #e3e4e8;
}

.tab-wrapper {
  .tabbox {
    &-item {
      height: 54px;
      padding: 0 32px;
    }
  }
}

.select-formbox-wrap {
  display: flex;
  justify-content: center;

  .selectbox-col {
    width: 278px;
    height: $layoutSelectboxColHeight;
    border-right: 1px solid rgb(227, 229, 232);
    margin: 24px 0;

    .height-scroll {
      height: $layoutSelectboxColHeight;
    }
  }

  & .formbox-col {
    width: calc(100% - 278px);
    padding: 0 0 0 24px;
  }
}

.history-tab {
  width: 1232px;
  border-bottom: 1px solid #d2d3d6;
}

.target-grid {
  padding: 0px 20px 0px 0px;

  .target-item__value {
    word-break: break-word;
  }

  .asg-product-name {
    background: #eef2fc;
    border-radius: 100px;
    padding: 6px;
    margin-top: 5px;
    font-size: 14px;
  }

  .server-list {
    margin-top: 36px;
  }
}
:deep(.scpm-insight-chart-container) {
  width: unset !important;
}
</style>
